export { CommunityPage as default, getStaticPaths, getStaticProps } from 'modules/community/pages/CommunityPage'
